import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.sass'],
})
export class ButtonComponent implements OnInit {
  @Input() title: string;
  @Input() classCustom: string;
  @Output() clickEvent: EventEmitter<any> = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  onClick(event: Event) {
    this.clickEvent.emit();
  }
}
